import { useState } from 'react';

export function useWizardStepData(initialData, onDataChange) {
  const [data, setDataState] = useState(initialData);

  const setData = (d: ((s: any) => any) | any) => {
    setDataState((current) => {
      const newData = typeof d === 'function' ? d(current) : d;

      onDataChange(newData);

      return newData;
    });

  };

  return [data, setData];
}
